module.exports = __webpack_public_path__ + "img/item2-2.73ade27f.jpg";